import React from 'react'
import MoviesList from '../Components/MoviesList';

const Movies = () => {
  return (
    <div>
      <MoviesList />
    </div>
  )
}

export default Movies
